import { render, staticRenderFns } from "./PicturePriorityToggle.vue?vue&type=template&id=6b2730b3&scoped=true"
import script from "./PicturePriorityToggle.vue?vue&type=script&lang=js"
export * from "./PicturePriorityToggle.vue?vue&type=script&lang=js"
import style0 from "./PicturePriorityToggle.vue?vue&type=style&index=0&id=6b2730b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2730b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VSnackbar})
